import React from "react";
import { Col, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from "reactstrap";
import { AboveInformationCorrect, CardNumber, Cvv, Expiration, Href, SelectPaymentMethod, Submit, UploadDocumentation } from "../../../../../../constants";
import { PaymentModeName } from "../../../../../../data/formsAndTable/forms/FormLayout";
import { WizardFormProps } from "../../../../../../types/Forms";

const CartInfoForm: React.FC<WizardFormProps> = ({ formData, updateFormData, register, errors }) => {
  return (
    <Form className="needs-validation custom-input" noValidate>
      <Row className="g-3">
        <Col xxl="6">
          <div className="card-wrapper border rounded-3 checkbox-checked">
            <h6 className="sub-title">{SelectPaymentMethod}</h6>
            <div className="radio-form">
              {PaymentModeName.map((data, index) => (
                <FormGroup check key={index}>
                  <Input id={`flexRadioDefault${index}`} type="radio" name="paymentMethod" defaultChecked={index === 2 ? true : false} />
                  <Label htmlFor={`flexRadioDefault${index}`} check>
                    {data}
                  </Label>
                </FormGroup>
              ))}
            </div>
          </div>
        </Col>
        <Col xxl="6">
          <Row>
            <Col xs="12" className="mb-4">
              <InputGroup>
                <Input {...register("recipientUserName", { required: "Recipient username is required" })} value={formData.recipientUserName} type="text" placeholder="Recipient's username" onChange={updateFormData} />
                <a className="btn btn-outline-secondary" href={Href}>
                  {Submit}
                </a>
              </InputGroup>
              {errors.recipientUserName && <span className="text-danger">{errors.recipientUserName.message}</span>}
            </Col>
            <Col xs="12">
              <InputGroup>
                <InputGroupText>{"@"}</InputGroupText>
                <Input {...register("userName", { required: "username is required" })} value={formData.userName} type="text" placeholder="Username" onChange={updateFormData} />
              </InputGroup>
              {errors.userName && <span className="text-danger">{errors.userName.message}</span>}
            </Col>
          </Row>
        </Col>
        <Col md="4" sm="6">
          <Label>{CardNumber}</Label>
          <Input {...register("cardNumber", { required: "Card number is required" })} value={formData.cardNumber} type="number" placeholder="xxxx xxxx xxxx xxxx" onChange={updateFormData} />
          {errors.cardNumber && <span className="text-danger">{errors.cardNumber.message}</span>}
        </Col>
        <Col md="4" sm="6">
          <Label>{Expiration}</Label>
          <Input {...register("expirationDate", { required: "Expiration date is required" })} value={formData.expirationDate} type="number" placeholder="xx/xx" onChange={updateFormData} />
          {errors.expirationDate && <span className="text-danger">{errors.expirationDate.message}</span>}
        </Col>
        <Col md="4" sm="6">
          <Label>{Cvv}</Label>
          <Input {...register("cvvNumber", { required: "CVV number is required" })} value={formData.cvvNumber} type="text" name="cvvNumber" onChange={updateFormData} />
          {errors.cvvNumber && <span className="text-danger">{errors.cvvNumber.message}</span>}
        </Col>
        <Col md="12" sm="6">
          <Label htmlFor="formFile2">{UploadDocumentation}</Label>
          <Input {...register("documentationName", { required: "Documentation file is required" })} id="formFile2" type="file" onChange={updateFormData} />
          {errors.documentationName && <span className="text-danger">{errors.documentationName.message}</span>}
        </Col>
        <Col xs="12">
          <FormGroup check className="mb-0">
            <Input id="invalidCheck-b" type="checkbox" required />
            <Label htmlFor="invalidCheck-b" check>
              {AboveInformationCorrect}
            </Label>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
export default CartInfoForm;
